

/**
 * Base API service for all services to inherit from
 * Contains additional functions for caching
 */
export default class BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    this.httpClient = httpClient
    this.reportingHttpClient = reportingHttpClient
    this.cacheExpiry = 15000    // 15 seconds
    this.cachedList = {}
  }


  /**
   * Perform a request with caching option
   */
  cachedGet(url, options = {}) {
    let curTimeMs = new Date().getTime()
    let cacheKey = url

    var existingKey = this.cachedList[cacheKey]

    if(existingKey) {

      // Check if expired
      if(curTimeMs - existingKey.time > this.cacheExpiry) {
        existingKey = null
        this.cachedList[cacheKey] = null
      }

      // If still loading, return the promise
      if(existingKey && existingKey.loading)
        return existingKey.request

      if(existingKey)
        return Promise.resolve(existingKey.data)
    }

    if(!existingKey) {
      let deferred = null
      if(options.reportingAPI)
        deferred = this.reportingHttpClient.get(url)
      else
        deferred = this.httpClient.get(url)
      
      this.cachedList[cacheKey] = {
        request: deferred,
        time: curTimeMs,
        deferred: deferred,
        loading: true,
        data: null
      }

      return deferred.then(result => {
        // Update cache
        if(this.cachedList[cacheKey]) {
          this.cachedList[cacheKey].loading = false
          this.cachedList[cacheKey].data = result
          this.cachedList[cacheKey].time = new Date().getTime()
        }

        return result
      })
    }
  }


}